/* eslint-disable */
export default {
  attachFiles: 'Bestand bijvoegen',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
